import { render, staticRenderFns } from "./FicharIncidencia.vue?vue&type=template&id=7beac488&"
import script from "./FicharIncidencia.vue?vue&type=script&lang=js&"
export * from "./FicharIncidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports